<section class="gemma-page">
  <div class="gemma-header">
    <div>
      <p class="eyebrow">R&D Lab</p>
      <h1>Gemma Voice Function</h1>
      <p class="subtext">Test voice-to-extraction for sentiment, intent, complaint fields, entities and recommended action.</p>
    </div>
    <div class="status-pill" [class.recording]="state === 'recording'" [class.failed]="state === 'failed'">
      <span></span>
      {{ statusLabel }}
    </div>
  </div>

  <div class="health-strip">
    <div>
      <strong>Model</strong>
      <span>{{ health?.modelId || 'google/gemma-4-12B-it' }}</span>
    </div>
    <div>
      <strong>Worker</strong>
      <span>{{ health?.status || 'Checking...' }}</span>
    </div>
    <div>
      <strong>Loaded</strong>
      <span>{{ health?.modelLoaded ? 'Yes' : (health?.modelLoading ? 'Downloading...' : 'Not loaded') }}</span>
    </div>
    <button type="button" class="ghost" (click)="loadHealth()">
      <span class="material-icons">refresh</span>
      Check
    </button>
    <button type="button" class="primary"
            [disabled]="health?.modelLoaded || health?.modelLoading"
            (click)="downloadModel()">
      <span class="material-icons">{{ health?.modelLoading ? 'hourglass_top' : 'download' }}</span>
      {{ health?.modelLoading ? 'Downloading...' : 'Download Model' }}
    </button>
  </div>

  <div class="gemma-grid">
    <div class="panel input-panel">
      <div class="panel-title">
        <span class="material-icons">mic</span>
        Voice Input
      </div>

      <div class="timer">{{ formattedDuration }}</div>
      <div class="meter" [class.live]="state === 'recording'">
        <span></span><span></span><span></span><span></span><span></span>
      </div>

      <div class="actions">
        <button type="button" class="primary" [disabled]="!canRecord" (click)="startRecording()">
          <span class="material-icons">fiber_manual_record</span>
          Record
        </button>
        <button type="button" class="danger" [disabled]="state !== 'recording'" (click)="stopRecording()">
          <span class="material-icons">stop</span>
          Stop
        </button>
        <label class="file-button">
          <span class="material-icons">upload_file</span>
          Upload Audio
          <input type="file" accept="audio/*" (change)="onFileSelected($event)">
        </label>
        <button type="button" class="ghost" [disabled]="state === 'recording' || state === 'analyzing'" (click)="clear()">
          <span class="material-icons">restart_alt</span>
          Clear
        </button>
      </div>

      <div class="audio-box" *ngIf="audioUrl; else emptyAudio">
        <div class="audio-meta">
          <span>{{ selectedFileName || 'Recorded audio' }}</span>
          <span>{{ fileSizeLabel }}</span>
          <span>{{ mimeType || 'audio/webm' }}</span>
        </div>
        <audio [src]="audioUrl" controls></audio>
      </div>
      <ng-template #emptyAudio>
        <div class="empty-audio">
          <span class="material-icons">graphic_eq</span>
          Record or upload an audio sample
        </div>
      </ng-template>

      <label class="field-label">
        Language
        <select [(ngModel)]="language">
          <option value="auto">Auto detect</option>
          <option value="ur">Urdu</option>
          <option value="en">English</option>
        </select>
      </label>

      <label class="field-label">
        Extraction Goal
        <textarea [(ngModel)]="extractionPrompt" rows="5"></textarea>
      </label>

      <button type="button" class="submit" [disabled]="!canAnalyze" (click)="analyze()">
        <span class="material-icons">psychology</span>
        {{ state === 'analyzing' ? 'Analyzing with Gemma...' : 'Analyze Voice' }}
      </button>
    </div>

    <div class="panel result-panel">
      <div class="panel-title">
        <span class="material-icons">auto_awesome</span>
        Gemma Extraction Result
      </div>

      <div class="error" *ngIf="errorMessage">{{ errorMessage }}</div>

      <ng-container *ngIf="result; else emptyResult">
        <div class="result-cards">
          <div>
            <span>Sentiment · {{ scorePercent(result.sentiment?.score) }}</span>
            <strong>{{ result.sentiment?.label || '-' }}</strong>
          </div>
          <div>
            <span>Intent · {{ scorePercent(result.intent?.score) }}</span>
            <strong>{{ result.intent?.label || '-' }}</strong>
          </div>
          <div>
            <span>Urgency · {{ scorePercent(result.urgency?.score) }}</span>
            <strong>{{ result.urgency?.label || '-' }}</strong>
          </div>
          <div>
            <span>Needs human review</span>
            <strong>{{ result.needsHumanReview ? 'Yes' : 'No' }}</strong>
          </div>
        </div>

        <div class="transcript-block">
          <h2>Transcript</h2>
          <p>{{ result.transcript || '-' }}</p>
        </div>

        <div class="two-col">
          <div class="info-box">
            <h2>Summary</h2>
            <p>{{ result.summary || '-' }}</p>
          </div>
          <div class="info-box">
            <h2>Recommended Action</h2>
            <p>{{ result.recommendedAction || '-' }}</p>
          </div>
        </div>

        <div class="entity-grid" *ngIf="entityEntries(result.entities).length">
          <div *ngFor="let entity of entityEntries(result.entities)">
            <span>{{ entity.key }}</span>
            <strong>{{ entity.value }}</strong>
          </div>
        </div>
      </ng-container>

      <ng-template #emptyResult>
        <div class="empty-result">
          Gemma extraction output will appear here after analysis.
        </div>
      </ng-template>

      <button type="button" class="raw-toggle" *ngIf="rawResponse" (click)="showRaw = !showRaw">
        {{ showRaw ? 'Hide' : 'Show' }} raw JSON
      </button>
      <pre class="raw" *ngIf="showRaw">{{ rawResponse }}</pre>
    </div>
  </div>
</section>
